var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFlip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59167 1.27002C7.59167 0.78677 7.19992 0.395019 6.71667 0.39502C6.23343 0.39502 5.84167 0.78677 5.84167 1.27002L7.59167 1.27002ZM6.09796 18.7263C6.43967 19.068 6.99368 19.068 7.33539 18.7263L12.9039 13.1578C13.2456 12.8161 13.2456 12.2621 12.9039 11.9204C12.5622 11.5787 12.0081 11.5787 11.6664 11.9204L6.71668 16.8701L1.76693 11.9204C1.42522 11.5787 0.871199 11.5787 0.529491 11.9204C0.187782 12.2621 0.187782 12.8161 0.529491 13.1578L6.09796 18.7263ZM5.84167 1.27002L5.84168 18.1076L7.59168 18.1076L7.59167 1.27002L5.84167 1.27002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5999 18.1077C17.5999 18.5909 17.2081 18.9827 16.7249 18.9827C16.2416 18.9827 15.8499 18.5909 15.8499 18.1077L17.5999 18.1077ZM16.1061 0.65139C16.4478 0.309681 17.0019 0.309681 17.3436 0.65139L22.912 6.21986C23.2537 6.56157 23.2537 7.11559 22.912 7.45729C22.5703 7.799 22.0163 7.799 21.6746 7.45729L16.7249 2.50755L11.7751 7.45729C11.4334 7.799 10.8794 7.799 10.5377 7.45729C10.196 7.11558 10.196 6.56156 10.5377 6.21986L16.1061 0.65139ZM15.8499 18.1077L15.8499 1.27011L17.5999 1.27011L17.5999 18.1077L15.8499 18.1077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlip);
export default __webpack_public_path__ + "static/media/icon-flip.4a766ba3f139b7cec752cfa4b84527cb.svg";
export { ForwardRef as ReactComponent };